import type { MeasureCategory } from '@/logic/oapAttainment';

// Tinted from the Remedy CATEGORY palette, never the status one, so a tile can't argue with the
// pill beside it. Decorative — the label names the measure.
const GLYPH: Record<MeasureCategory, string> = {
  heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z',
  body: 'M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM5 21v-2a7 7 0 0 1 14 0v2',
  respiratory: 'M9 3h6M10 3v6l-4.5 8a2 2 0 0 0 1.7 3h9.6a2 2 0 0 0 1.7-3L14 9V3',
  neutral: 'M8 4C4.5 4 3 8 3.5 12S6 20 9 20c2.2 0 3-1.8 3-4V8c0-2.2-1.5-4-4-4zM16 4c3.5 0 5 4 4.5 8S18 20 15 20c-2.2 0-3-1.8-3-4V8c0-2.2 1.5-4 4-4z',
};

export default function MeasureTile({ category }: { category: MeasureCategory }) {
  return (
    <span
      className="oap-tile"
      aria-hidden="true"
      style={{
        background: `var(--wi-category-${category}-background-card)`,
        color: `var(--wi-category-${category}-icon)`,
      }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d={GLYPH[category]} />
      </svg>
    </span>
  );
}
